import { request } from '@/utils/http'

export const getOfficialBookInfo = (id: any) => request('GET', `/official/book/${id}`)

export const getOfficialTreeInfo = (id: any) => request('GET', `/official/book/${id}/sections`)

export const copyOfficialCourseware = (params: any) => request('POST', '/teacher/courseware/copy-from-official', params)

export const addDownloadLog = (id: string) => request('POST', `/official/courseware/${id}/add-download-log`)
